import AdminFaxSearch from './admin-fax-search-component';
import AdminFaxSearchService from './admin-fax-search-service';

import './admin-fax-search.scss';

const MODULE_NAME = 'App.admin.fax.search';
const module = angular
    .module(MODULE_NAME, [])
    .directive('ktAdminFaxSearch', AdminFaxSearch)
    .service('adminFaxSearchService', AdminFaxSearchService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-fax/admin-fax-search/admin-fax-search-module.js